import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Typography } from "@mui/material";
import LegalPage from "../Components/Legal/LegalPage";
import { COOKIE_CONSENT_KEY, COOKIE_CONSENT_EVENT } from "../Components/CookieConsent";

export default function CookiePolicy() {
  const handleManagePreferences = () => {
    try {
      localStorage.removeItem(COOKIE_CONSENT_KEY);
    } catch (e) {
      // ignore storage errors
    }
    window.dispatchEvent(new Event(COOKIE_CONSENT_EVENT));
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  return (
    <div>
      <Helmet>
        <title>Cookie Policy – GroHair & GloSkin – Cumbum</title>
        <meta
          name="description"
          content="Learn how Advanced GroHair & GloSkin, Cumbum uses cookies, and how to manage your cookie preferences."
        />
        <meta property="og:title" content="Cookie Policy – GroHair & GloSkin – Cumbum" />
        <meta
          property="og:description"
          content="Learn how Advanced GroHair & GloSkin, Cumbum uses cookies, and how to manage your cookie preferences."
        />
        <meta property="og:url" content="https://adgrohairgloskincumbum.in/cookie-policy" />
        <meta property="og:type" content="website" />
      </Helmet>

      <LegalPage title="Cookie Policy" lastUpdated="August 28, 2026">
        <Box mb={3}>
          <Typography sx={{ mb: 1.5, fontSize: "0.95rem", color: "#333" }}>
            Want to change your choice? You can reopen the cookie preference banner at any time.
          </Typography>
          <button className="legal-manage-btn" onClick={handleManagePreferences}>
            Manage Cookie Preferences
          </button>
        </Box>

        <div
          dangerouslySetInnerHTML={{
            __html: `
            <h2>What Are Cookies?</h2>
            <p>Cookies are small text files that are placed on Your computer, mobile device or any other device by a website, containing details of Your browsing history on that website, among its many uses. Cookies help us recognise You, remember Your preferences, and understand how You use our website, <a href="https://adgrohairgloskincumbum.in/" target="_blank" rel="noopener noreferrer">https://adgrohairgloskincumbum.in/</a>.</p>

            <h2>How We Use Cookies</h2>
            <p>When You first visit Our website, You will see a cookie banner asking You to <strong>Accept</strong>, <strong>Reject</strong>, or <strong>Customize</strong> Your cookie preferences. Your choice is remembered on this device so that You are not asked again on every visit, until You change Your preference using the "Manage Cookie Preferences" button above or Your browser settings.</p>
            <p>We use both Session and Persistent Cookies for the purposes set out below:</p>

            <h3>Necessary / Essential Cookies</h3>
            <p><strong>Type:</strong> Session Cookies &nbsp;|&nbsp; <strong>Administered by:</strong> Us</p>
            <p>These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features, such as booking an appointment. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services. These cannot be switched off.</p>

            <h3>Cookies Policy / Notice Acceptance Cookies</h3>
            <p><strong>Type:</strong> Persistent Cookies (stored in Your browser's local storage) &nbsp;|&nbsp; <strong>Administered by:</strong> Us</p>
            <p>These identify whether You have accepted the use of cookies on the Website and record the consent choice You have made (Accept / Reject), so that We can honor that choice on future visits.</p>

            <h3>Functionality Cookies</h3>
            <p><strong>Type:</strong> Persistent Cookies &nbsp;|&nbsp; <strong>Administered by:</strong> Us</p>
            <p>These allow Us to remember choices You make when You use the Website, such as language or display preferences, so You do not have to re-enter them on every visit.</p>

            <h3>Analytics and Advertising Cookies</h3>
            <p><strong>Type:</strong> Persistent / Third-Party Cookies &nbsp;|&nbsp; <strong>Administered by:</strong> Third parties (e.g. Google Analytics, Google Tag Manager, Google Ads, Meta/Facebook Pixel)</p>
            <p>These help us understand how visitors interact with Our website, which pages are most popular, and how effective Our marketing campaigns are. These Cookies are set only where You have accepted cookies via Our banner, or via Your browser settings, where required by applicable law.</p>

            <h2>Managing Cookies</h2>
            <p>You can manage or withdraw Your cookie consent at any time by:</p>
            <ul>
              <li>Clicking the <strong>"Manage Cookie Preferences"</strong> button at the top of this page, which will reopen the cookie banner; or</li>
              <li>Adjusting Your browser settings to refuse or delete cookies. Please note that if You disable cookies, some parts of Our website may not function as intended.</li>
            </ul>

            <h2>More Information</h2>
            <p>For more detail on how We collect, use, and protect Your personal information generally, please see Our <a href="/privacy-policy">Privacy Policy</a>.</p>

            <h2>Contact Us</h2>
            <p>If you have any questions about this Cookie Policy, You can contact us:</p>
            <ul>
              <li>By email: <a href="mailto:adgrohaircbm@gmail.com">adgrohaircbm@gmail.com</a></li>
              <li>By phone: <a href="tel:+919962556789">+91 99625 56789</a></li>
              <li>In person: First Floor, LF Rd, Opp Urban Hospital, Nethaji Nagar, Pathirakaliamman Kovil, Cumbum, Tamil Nadu 625516</li>
            </ul>
            `,
          }}
        />
      </LegalPage>
    </div>
  );
}
